import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "primereact/button";

import { getTokenInfo } from "../../../utils/Guard";
import { GetDepartments } from "../../../store/department-store/department-actions";
import { departmentActions } from "../../../store/department-store/department-slice";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";

const DepartmentsHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const department = useSelector((state) => state.department);

  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("department.showAll")
    ) {
      dispatch(GetDepartments(userInfo.Email, true));
    } else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("department.menu")
    ) {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Roles, userInfo.Email]);

  const viewDetailHanlder = (val) => {
    navigate(`/departments/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/departments/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      departmentActions.setDepartment({
        department: {
          id: 0,
          name: "",
          description: "",
          status: false,
        },
      })
    );
    navigate(`/departments/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("department.edit")
    ) {
      buttons.push(buttonEdit);
    }
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("department.view")
    ) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "118vh" }}
      >
        <ABADatatable
          width="20%"
          title="Departamentos"
          values={department.departments}
          rows={8}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Agregar",
            onClick: createHanlder,
            permission: "department.create",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }}
        />
      </div>
    </>
  );
};
export default DepartmentsHomePage;
